// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fileinfo-detail-container {
    margin-top: 1%;

    .fileinfo-details {
        margin-top: 0px;
        padding: 20px;
        padding-top: 5px;
    }

    .MuiTypography-root {
        font-size: 0.9rem !important;
    }

    .MuiPaper-elevation {
        width: 95% !important;
        padding: 15px;

    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/filesinfo.css"],"names":[],"mappings":"AAAA;IACI,cAAc;;IAEd;QACI,eAAe;QACf,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;QACrB,aAAa;;IAEjB;AACJ","sourcesContent":[".fileinfo-detail-container {\n    margin-top: 1%;\n\n    .fileinfo-details {\n        margin-top: 0px;\n        padding: 20px;\n        padding-top: 5px;\n    }\n\n    .MuiTypography-root {\n        font-size: 0.9rem !important;\n    }\n\n    .MuiPaper-elevation {\n        width: 95% !important;\n        padding: 15px;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
